import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue';
// import LoginPage from './views/LoginPage.vue';

import firebase from 'firebase/app';
import 'firebase/auth';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import ('./views/Home.vue'),
      beforeEnter: (to, from, next) => {
        firebase.auth().onAuthStateChanged((user) => {
          if (user) {
            firebase.auth().currentUser!!.getIdToken(true);
            next();
          } else {
            next('/login');
          }
        });
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import ('./views/LoginPage.vue'),
    },
  ],
});
